import $ from 'jquery';

import { parseQuery } from '../../getQueryObj';
import getDLRCD from '../../fetch/getDLRCD';
import createOption from '../createOption';
import setBrnhcdSelectBoxOptions from '../setBrnhcdSelectBoxOptions';

const setupPrgSelectBoxOnChange = (userInfo, prgList) => {
	$('#prglist-selectbox').on('change', async (event) => {
		let buttonDisable = false;

		$('#password-login-button').addClass('-disable');
		$('.field[data-rel="apiWORKNO"]').addClass('-hide');

		/**
		 * clean the form
		 */
		$('.body.-workno > .sub-info').addClass('-hide');
		$('.body.-workno > .sub-info > .field').addClass('-hide');
		$('.body.-workno > .sub-info > .field').find('option').remove();
		$('.body.-workno > .sub-info > .field').find('input').val('');

		/**
		 * clean the error message
		 */
		$('.message-box').removeClass('-warning');
		$('.message-box').text('');

		const listIndex = event.target.value;
		const queryStr = prgList[listIndex].PGMURL.split('?')[1] || '';
		const queryObj = parseQuery(queryStr);

		if ($('#prglist-selectbox').attr('data-fran')) {
			$('#prglist-selectbox').removeAttr('data-fran');
		}
		if ($('#prglist-selectbox').attr('data-branch-kind')) {
			$('#prglist-selectbox').removeAttr('data-branch-kind');
		}

		if (prgList.WRKGRPID !== 'CAS') {
			for (const key in queryObj) {
				if (Object.hasOwnProperty.call(queryObj, key)) {
					const str = queryObj[key];
					/**
					 * 顯示 輸入車號
					 */
					if (str === 'txtLICSNO') {
						buttonDisable = true;
						$('.body.-workno > .sub-info').removeClass('-hide');
						$('.body.-workno .field[data-rel="licsno"]').removeClass('-hide');
					}

					/**
					 * 顯示 選擇經銷商
					 */
					if (str === 'apiDLRCD') {
						buttonDisable = true;
						$('.body.-workno > .sub-info').removeClass('-hide');

						/* eslint-disable no-await-in-loop */
						const { DLRCDLIST } = await getDLRCD(`JsonStr={
							DLRCD: "${userInfo[0].DLRCD}",
							BRNHCD: "${userInfo[0].BRNHCD}",
							USERID: "${userInfo[0].USERID}"
						}`);
						/* eslint-enable no-await-in-loop */

						DLRCDLIST.forEach(({ DLRNM, DLRCD }) => {
							$('#api-DLRCD').append(createOption(DLRNM, DLRCD));
						});

						$('.body.-workno .field[data-rel="apiDLRCD"]').removeClass('-hide');
					}

					/**
					 * 顯示 據點 (T / L)
					 * 依據參數 apiDLRCD 或 varDLRCD 判定帶入的 DLRCD
					 */
					if (str === 'apiTBRNHCD' || str === 'apiLBRNHCD' || str === 'apiTSABRNH' || str === 'apiLSABRNH') {
						buttonDisable = true;
						$('#prglist-selectbox').attr(
							'data-fran',
							str === 'apiTBRNHCD' || str === 'apiTSABRNH' ? 'T' : 'L',
						);
						$('#prglist-selectbox').attr(
							'data-branch-kind',
							str === 'apiTSABRNH' || str === 'apiLSABRNH' ? '02' : '03',
						);
						setBrnhcdSelectBoxOptions(
							$('.body.-workno .field[data-rel="apiDLRCD"]').hasClass('-hide')
								? userInfo[0].DLRCD : $('#api-DLRCD').val(),
						);

						$('.body.-workno > .sub-info').removeClass('-hide');
						$('.body.-workno .field[data-rel="apiBRNHCD"]').removeClass('-hide');
					}
				}
			}
		} else {
			/**
			 * 顯示 輸入車號
			 */
			buttonDisable = true;
			$('.body.-workno > .sub-info').removeClass('-hide');
			$('.body.-workno .field[data-rel="licsno"]').removeClass('-hide');
		}

		if (!buttonDisable) {
			$('#password-login-button').removeClass('-disable');
		}
	});
};

export default setupPrgSelectBoxOnChange;



// WEBPACK FOOTER //
// ./src/js/index/onChange/setupPrgSelectBoxOnChange.js